import { render } from "./checkbox.vue?vue&type=template&id=2e89a2cc&lang=pug"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"
script.render = render

export default script